import React from 'react';
import PropTypes from 'prop-types';
import TextButton from 'components/TextButton';
import BattleChallengeLogo from 'resources/BattleChallengeLogo.png';
import CloseIcon from 'resources/icon-close-white.svg';
import FilterIcon from 'resources/Icon_Filter.png';
import AllItems from './assets/WStore_All.png';
import CasinoTicket from './assets/WStoreCat_CasinoTickets.png';
import DrawingTickets from './assets/WStore_OnlineEntries.png';
import FoodCredit from './assets/WStore_FoodCredit.png';
import FreePlay from './assets/WStore_FREEPlay.png';
import Hotel from './assets/WStore_HotelBooking.png';
import HotPicks from './assets/WStore_HotPicks.png';
import Merchandise from './assets/WStoreCat_Merchandise.png';
import Partners from './assets/WStore_Partners.png';
import PlaceHolderWStoreIcon from './assets/Placeholder-WstoreCategory.png';
import PromoPerks from './assets/WStore_PromoPerks.png';
import PropertyPerks from './assets/WStore_PropertyPerks.png';
import Quest from './assets/WStore_Quests.png';
import Spa from './assets/WStore_Spa.png';
import VersePerks from './assets/WStore_VersePerks.png';
import './WStoreCategories.css';

const CATEGORY_ICONS = {
  'All Item Types': AllItems,
  'Battle Challenge': BattleChallengeLogo,
  'Casino Ticket': CasinoTicket,
  'Food Credits': FoodCredit,
  'Free Play': FreePlay,
  'Hot Picks': HotPicks,
  Hotel: Hotel,
  Merchandise: Merchandise,
  'Online Entries': DrawingTickets,
  'Promo Perks': PromoPerks,
  'Property Perks': PropertyPerks,
  'Verse Perks': VersePerks,
  Partners: Partners,
  Quest: Quest,
  Spa: Spa
};

function WStoreCategories(props) {
  return (
    <div className="wstore-categories">
      <div className="categories-title-container">
        <img src={FilterIcon} alt="" />
        <span>Select A WStore Category</span>
      </div>
      <div className="categories-subtext-container">
        What are you shopping for?
        <br />
        The following items are currently available at{' '}
        {props.location || 'your preferred location'}
      </div>
      <div className="categories-container">{renderCategories(props)}</div>
      <TextButton className="wstore-categories-close" onClick={props.onClose}>
        <img src={CloseIcon} alt="Close WStore Categories Modal" />
      </TextButton>
    </div>
  );
}

function renderCategories(props) {
  const currCat =
    props.showDiscover && props.enableDiscover
      ? 'Discover'
      : props.currCategoryFilter.value;

  const wstoreCategories = props.categories.map((cat, index) => {
    const imageSrc = CATEGORY_ICONS[cat.name] || PlaceHolderWStoreIcon;
    const categoryName = cat.name === 'Quest' ? 'Quests' : cat.name;

    return (
      <div
        className={`category ${cat.value === currCat ? 'selected' : ''}`}
        key={index}
      >
        <TextButton onClick={() => handleCategorySelection(props, cat)}>
          <img src={imageSrc} alt="" />
        </TextButton>
        <span className="category-name">{categoryName}</span>
      </div>
    );
  });

  return wstoreCategories;
}

function handleCategorySelection(props, category) {
  if (category.value === 'All') {
    props.onSelectAllCategory();
  } else if (category.value === 'Hot Picks') {
    props.onSelectHotPicks();
  } else if (category.value === 'Discover') {
    props.onSelectDiscover();
  } else {
    props.onSelectCategory(category);
  }
  props.onClose && props.onClose();
}

WStoreCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  onSelectHotPicks: PropTypes.func.isRequired,
  onSelectAllCategory: PropTypes.func.isRequired,
  currCategoryFilter: PropTypes.object,
  location: PropTypes.string,
  onClose: PropTypes.func
};

export default WStoreCategories;
